// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EJa32hDYdx_WDT {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.zQh45kCxRCt3YY {
  display: inline-flex;
  color: var(--ds-text-subtle, #44546f);
  font-weight: 600;
}
.qb07UgUCxWwNSb {
  display: inline-flex;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.YvwLXiAPZyzLRs {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.Rhcv22C0avKHw6 {
  margin: 0 4px 0 0;
  text-decoration: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewCopyComponent": `EJa32hDYdx_WDT`,
	"viewCopyText": `zQh45kCxRCt3YY`,
	"viewCopyTextSmall": `qb07UgUCxWwNSb`,
	"iconViewCopy": `YvwLXiAPZyzLRs`,
	"shareTemplateButton": `Rhcv22C0avKHw6`
};
export default ___CSS_LOADER_EXPORT___;
